import React, { useState, useRef, useEffect } from "react";
import { SketchPicker } from "react-color";
import reactCSS from "reactcss";

export const ColorPicker = ({ onChange, color, className = "", isMultiEdit = false }) => {
    const [showPicker, setShowPicker] = useState(false);
    const popoverRef = useRef(null);

    useEffect(() => {
        if (showPicker && popoverRef.current) {
            popoverRef.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
    }, [showPicker]);
    const styles = reactCSS({
        default: {
            color: {
                width: "40px",
                height: "15px",
                borderRadius: "3px",
                background: color
            },
            popover: {
                position: "absolute",
                zIndex: "3"
            },
            cover: {
                position: "fixed",
                top: "0px",
                right: "0px",
                bottom: "0px",
                left: "0px"
            },
            swatch: {
                padding: "6px",
                background: "#ffffff",
                borderRadius: "2px",
                cursor: "pointer",
                display: "flex",
                width: "max-content",
                ...(isMultiEdit ? {} : { margin: "0 auto" }),
                boxShadow: "0 0 0 1px rgba(0,0,0,.2)"
            }
        }
    });
    return (
        <div className={className}>
            {isMultiEdit ? (
                <div className="close-icon-right position-relative">
                    <span
                        onClick={e => {
                            e.stopPropagation();
                            onChange("");
                            setShowPicker(false);
                        }}
                    >
                        <i className="fas fa-times"></i>
                    </span>
                </div>
            ) : null}
            <div
                className={isMultiEdit ? "ml-0" : ""}
                style={styles.swatch}
                onClick={() => {
                    setShowPicker(!showPicker);
                }}
            >
                <div style={styles.color} />
            </div>
            {showPicker ? (
                <div style={styles.popover} ref={popoverRef}>
                    <div
                        style={styles.cover}
                        onClick={() => {
                            setShowPicker(false);
                        }}
                    />
                    <SketchPicker
                        type="color"
                        color={color || ""}
                        presetColors={["#95cd50", "#ffe242", "#ffa105", "#ff0305", "#525252", "#343C65", "#8B572A", "#417505"]}
                        onChange={color => {
                            onChange(color.hex);
                        }}
                    />
                </div>
            ) : null}
        </div>
    );
};
